import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Spinner from '../../components/Spinner'
import { getHomeData } from '../../actions/contentActions'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import CollectionsSet from '../../components/CollectionsSet'
import Platform from '../../platforms/index.js'
import UrgentMessageModal from '../../components/UrgentMessageModal'
import { createPortal } from 'react-dom'

export class HomeScreen extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      collections: null,
      collectionsReady: false,
      toggleMessageUI: false,
    }
  }

  prepareHomeContent() {
    const hasHomeContent =
      Array.isArray(this.props.homeCollections) &&
      this.props.homeCollections.length > 0

    if (hasHomeContent) {
      this.setState({
        collections: this.props.homeCollections,
        collectionsReady: true,
      })
    }
  }

  componentDidMount() {
    const { UID } = this.props
    Platform.reportAppReady()

    if (!Array.isArray(this.props.homeCollections)) {
      getHomeData(this.props.stationId, UID)
    }

    //When you navigate from Shows to Home in the SidePanel,
    //you need to update the states to display the content.
    this.prepareHomeContent()

    googleAnalytics4.sendPageViewEvent('Home')

    // GOOGLE ANALYTICS
    /* window.ga('set', 'dimension1', callSign)
    window.ga('set', 'dimension2', UID)
    window.ga('set', 'dimension3', deviceModel)
    window.ga('send', 'pageview', 'Home') */

    if (
      !Platform.userSawMessage &&
      Platform.getMessageValidations().isValid &&
      Platform.isMessageAvailableForEnv()
    ) {
      //Send GA analytics ? Send mux event ?
      this.setState({
        toggleMessageUI: true,
      })
    }
  }

  handleCloseModal() {
    this.setState({ toggleMessageUI: false })
    Platform.userSawMessage = true
  }

  componentDidUpdate(prevProps) {
    if (prevProps.homeCollections != this.props.homeCollections) {
      this.prepareHomeContent()
    }
  }

  isDoneFetching() {
    return this.state.collectionsReady
  }

  render() {
    const { collections, toggleMessageUI } = this.state

    const doneFecthing = this.isDoneFetching()

    return (
      <>
        {!doneFecthing && <Spinner />}
        {doneFecthing && (
          <>
            {toggleMessageUI &&
              createPortal(
                <UrgentMessageModal
                  onCloseModal={this.handleCloseModal.bind(this)}
                />,
                document.getElementById('app')
              )}
            <CollectionsSet collections={collections} />
          </>
        )}
      </>
    )
  }
}

HomeScreen.propTypes = {
  UID: PropTypes.string,
  callSign: PropTypes.string,
  deviceModel: PropTypes.string,
  stationId: PropTypes.string,
  homeCollections: PropTypes.any,
  dispatch: PropTypes.func,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  isLivestreamAvailable: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    stationId: state.station.station_id,
    callSign: state.station.call_sign,
    UID: state.device.UID,
    deviceModel: state.device.deviceModel,
    homeCollections: state.homeContent.collections,
    isLivestreamAvailable: state.multilivestream.isLivestreamAvailable,
    messageData: state.messageData,
  }
}

export default connect(mapStateToProps, null, null)(HomeScreen)
